
<script>
export default {
    name: "HeadTitle",
    props: [
        'title'
    ],
    created() {
        this.title = 'Fluxum'
    },
    watch: {
        title: {
            immediate: true,
            handler() {
                document.title = this.title
            }
        }
    }
}
</script>
